import { MemoizedSelector, createFeatureSelector, createSelector } from '@ngrx/store';
import { AuthState } from './auth.state';
import { environment } from '../../../environments/environment';

export const select: MemoizedSelector<object, AuthState> = createFeatureSelector<AuthState>('auth');
export const selectCurrentUser = createSelector(select, state => state.currentUser);
// No user at all (the anonymous session could not be started) counts as anonymous too: this is what shows the
// login/register entry points and locks users-only features.
export const selectIsAnonymous = createSelector(select, state =>
	state.currentUser ? state.currentUser.roles.indexOf('AnonymousUser') !== -1 : true
);
export const selectToken = createSelector(select, state => state.access_token);
export const selectRefreshToken = createSelector(select, state => state.refresh_token);
export const selectAnonymousToken = createSelector(select, state => state.anonymous_token);
export const selectLoading = createSelector(select, state => state.loading);
export const selectLocation = createSelector(select, state => state.location);
export const selectLockAnonymousFeatures = createSelector(selectIsAnonymous, isAnonymous =>
	isAnonymous && environment.lockAnonymousFeatures);

export const selectError = createSelector(select, state => state.error);

// This is already handled: AuthState.loading defaults to true (see initialAuthState in auth.state.ts) and
// only flips false once the current user is actually resolved. shared/guards/loaded.guard.ts gates the
// app's entire root route on it, so currentUser === null is never reachable in the main app while still
// loading - it's only ever seen once loading has genuinely finished.
